import { render, staticRenderFns } from "./photoView.vue?vue&type=template&id=5b3ccc36"
import script from "./photoView.vue?vue&type=script&lang=js"
export * from "./photoView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports